import { NgModule } from '@angular/core';
import { NavbarComponent } from './navbar.component';
import { NavbarItem } from './navbar-item';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { EdAssistUIButtonLinkModule } from '@edassist-ui/button-link';
import { EdAssistUIButtonDropDownModule } from '@edassist-ui/button-drop-down';

const COMPONENTS = [NavbarComponent];

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		EdAssistUIButtonLinkModule,
		EdAssistUIButtonDropDownModule
	],
	exports: COMPONENTS,
	declarations: COMPONENTS
})
class EdAssistUINavbarModule {}

export { EdAssistUINavbarModule, NavbarComponent, NavbarItem };
